export default __webpack_public_path__ + "static/media/panda.50dcd06929ed9f1e791339f549416d9a.png";